<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{item ? 'Edit' : 'Add New'}} {{config.title.slice(0, -1)}}
</h1>
<div mat-dialog-content>
  @if (form) {
    <form class="form" [formGroup]="form" padding>
      @for (field of fields; track field) {
        <div>
          @if (field.fieldType === FIELD_SECTION) {
            <div [ngStyle]="{'margin-left': field.level * LEVEL_OFFSET + 'px'}" class="section">
              <span [ngStyle]="{'font-size': 'calc(16pt - ' + field.level * 2 + 'pt)'}" class="sectionlabel">{{field.label | desnake}}</span>
            </div>
          }
          @if (field.fieldType === 'Boolean') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'boolean'"></app-addeditfield>
          }
          @if (field.fieldType === 'Number') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'number'"></app-addeditfield>
          }
          @if (field.fieldType === 'String' || field.fieldType === 'UUID') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'text'"></app-addeditfield>
          }
          @if (field.fieldType === 'Date' || field.fieldType === 'DateNow') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'datetime-local'"></app-addeditfield>
          }
          @if (field.fieldType === 'Color') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'color'"></app-addeditfield>
          }
          @if (field.fieldType === 'HTML') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'html'"></app-addeditfield>
          }
          @if (field.fieldType === 'ARRAY') {
            <app-addeditfield [formGroup]="form" [field]="field" [inputType]="'array'"></app-addeditfield>
          }
          @if (field.fieldType === 'File') {
            <div class="filetitle">
              <mat-label  class="fileformlabel" [ngStyle]="{'margin-bottom': '5px', 'margin-left': field.level * LEVEL_OFFSET + 'px'}">{{field.label | desnake}}</mat-label>
              @if (versions.length > 1) {
                <mat-form-field >
                  <mat-select formControlName="_versionselect" placeholder="Version...">
                    @for (version of versions; track version; let i = $index) {
                      <mat-option [value]="version">{{version.last_modified | date: 'medium'}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }
          @if (field.fieldType === 'File') {
            <ngx-dropzone [ngStyle]="{'background-color': '#f8f8f8', 'margin-bottom': '20px', 'margin-left': field.level * LEVEL_OFFSET + 'px',  width: 'calc(100% - ' + field.level * LEVEL_OFFSET + 'px)'}" (change)="onSelect($event, field)" [multiple]="false">
              <ngx-dropzone-label>Drag a file or click to browse@if (field.required) {
                <span class="required">*</span>
              }</ngx-dropzone-label>
              @for (f of files; track f) {
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" [file]="f" [removable]="true" (removed)="onRemove(f, field)">
                  <ngx-dropzone-label class="filelabel">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-image-preview>
              }
            </ngx-dropzone>
          }
        </div>
      }
    </form>
  }
</div>
<span class="required" >* Required Field</span>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button [disabled]="!form.valid" class="donebutton" color="primary" (click)="okClicked()">OK</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
